import { addNamespaceInOperations } from '../helper'
import servicePlaka from '@/services/connection/plaka'

import Vue from 'vue'

export const MUTATIONS_METHODS = {
  SET_FILTERS: 'setDimension'
}

export const mutations = {
  [MUTATIONS_METHODS.SET_FILTERS] (state, { filters = [], fields2notify }) {
    Vue.set(state, 'filters', filters)
    servicePlaka.evaluate(fields2notify)
  }
}

export const MUTATIONS = addNamespaceInOperations('plaka', MUTATIONS_METHODS)
